import styled from "styled-components";

export const SimCardTrafficPoolManagementWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0px;
    padding: 0px 20px;
`;

export const ToolBarLeftWrapper = styled.div`
    flex: 0 0 auto;
`;

export const ToolBarRightWrapper = styled.div`
    flex: 0 0 auto;
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & .ant-select-selector {
        overflow: hidden;
    }

    & .ant-select-selection-overflow {
        flex-wrap: nowrap;
    }
`;

export const FilterItemLabel = styled.div`
    font-size: 12px;
    color: #333333;
    text-align: left;
    padding-left: 10px;
    margin-bottom: 5px;
    box-sizing: border-box;
    letter-spacing: 2px;
`;

export const PoolsWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    border-radius: 5px;
    overflow: hidden;
`;

export const PoolCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
    width: 350px;
    background-color: rgba(0, 0, 0, 0.025);
    border-radius: 10px;
    transition: all 0.5s ease-in-out;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
`;

export const PoolCardTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #333333;
`;

export const SimCardPoolIcon = styled.div`
    display: inline-block;
    font-size: 28px;
`;

export const PoolCardTitleText = styled.a`
    display: inline-block;
    cursor: pointer;
`;

export const PoolInfoGroup = styled.div`
    display: flex
    flex-direction: column;
    align-items: stretch;
    margin-top: 10px;
`;

export const PoolInfoGroupTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    padding: 10px 2px;
`;

export const PoolCardInfoItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 5px 2px;
`;

export const PoolCardInfoItemLabel = styled.div`

`;

export const PoolCardInfoItemValue = styled.div`
    font-weight: 400;
`;

export const TrafficUsageText = styled.div`
    display: inline-block;
    width: 40px;
    text-align: right;
`;



